import {Component, OnInit} from '@angular/core';
import {AngularFireAuth} from '@angular/fire/compat/auth';
import {Router} from '@angular/router';
import {Observable} from 'rxjs';
import {AuthService} from 'projects/firebase/src/lib/services/auth.service';
import {GoogleTagService} from 'projects/shared/src/lib/services/google-tag.service';

@Component({
  selector: 'app-confirm-sign-in',
  templateUrl: './confirm-sign-in.component.html',
  styleUrls: ['./confirm-sign-in.component.scss']
})
export class ConfirmSignInComponent implements OnInit {
  user;
  email: string;
  emailSent = false;

  errorMessage: string;

  constructor(
    public afAuth: AngularFireAuth,
    private router: Router,
    private auth: AuthService,
    private gtService: GoogleTagService
  ) {
  }

  ngOnInit() {
    this.user = this.afAuth.user;
  }

  confirmEmail() {
    const email: string = window.localStorage.getItem('email');
    const url = window.location.href;

    this.auth.confirmSignIn(email, url)
      .then(() => this.gtService.event('login_success'))
      .then((res) => {
      }, (error) => {
      });

  }

  logout() {
    return this.afAuth.signOut();
  }
}
